import React from "react";
import { useTranslation } from "react-i18next";
import {
  useRetrieveCurrentPlanzone,
  useZonesProjectsRetrieval,
} from "@planzone/view-models";

import { Loader } from "../loader";
import { ScrollPane } from "../scrollPane";
import { Section } from "../section";
import { filterSearch } from "../utils";
import { Props } from "./types";
import { Zone } from "./zone";
import { groupByZone } from "./utils";
import styles from "./styles.scss";

function Zones({
  search,
  zone,
  selectedProject,
  onSelectProject,
  isOpen,
}: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    projects,
    retrieveZonesProjects,
  } = useZonesProjectsRetrieval();

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveZonesProjects(planzone);
  }, []);

  return (
    <Section
      header={
        <div className={styles.header}>
          <p className={styles.title}>{t("common.filterMenu.zones.title")}</p>
        </div>
      }
      list={
        <ScrollPane>
          <div className={styles.list}>
            {!isRequestPending ? (
              [
                ...filterSearch(
                  groupByZone(
                    zone
                      ? projects.filter((p) => p.zone.uuid === zone.uuid)
                      : projects,
                  ),
                  search,
                ),
              ]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((zoneGroup) => (
                  <Zone
                    key={zoneGroup.uuid}
                    search={search}
                    zone={zoneGroup}
                    selectedProject={selectedProject}
                    onSelectProject={onSelectProject}
                  />
                ))
            ) : (
              <div className={styles.loader}>
                <Loader />
              </div>
            )}
          </div>
        </ScrollPane>
      }
      isHeaderToggleDisabled
      isOpen={isOpen}
    />
  );
}

export { Zones };
